module.exports = __webpack_public_path__ + "img/nanjingDsq.931884c.png";